import React, { useState } from "react";
import { NepaliDatePicker } from "datepicker-nepali-reactjs";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import UseInput from "../UseInput";
import "react-toastify/dist/ReactToastify.css";
import Comments from "./Comments";
import "./style.css";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Api from "../../services/api";
import { BSToAD } from "../../utils/dateUtils";

export default function ModalComp({
  gnid,
  disabled,
  stage_id,
  fiscalYear,
  token,
  comment,
  question_id,
  dateRequired,
  localData,
  ocmcm_id,
}) {
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [date, setDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [posted, setPosted] = useState(false);
  const [pastDate, isPastDate] = useState(false);
  const [commentCount, setCommentCount] = useState(stage_id);

  const { value: message, bind: bindComment, reset: resetComment } = UseInput(
    ""
  );
  const toggle = () => setModal(!modal);
  const toggle2 = () => setModal2(!modal2);
  const getDate = (event) => {
    setDate(event);
    isValidDate(event) && setDate(event);
  };

  const isValidDate = (date) => {
    var d = new Date();
    d.setHours(0, 0, 0, 0);
    if (date) {
      const today = Date.parse(d);
      const selectedDate = Date.parse(BSToAD(date));
      if (today > selectedDate) {
        setDate("");
        isPastDate(true);
        return false;
      }

      isPastDate(false);
      return true;
    }
  };

  const PostComment = async (event) => {
    event.preventDefault();
    // setLoading(true);
    setCommentCount(commentCount + 1);

    let gnid = ocmcm_id
      ? window.location.search.substring(6)
      : sessionStorage.getItem("m_id");
    let response = await Api.postComments({
      fiscal_year_id: fiscalYear,
      question_id: question_id,
      ministry_id: gnid,
      message: message,
    });

    if (response.code === 200) {
      toast(response.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        type: toast.TYPE.SUCCESS,
      });
      setPosted(true);
      resetComment();
      setLoading(false);
      // window.location.reload(false);
    } else {
      toast("Something went wrong, Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        type: toast.TYPE.ERROR,
      });
      setDate(false);
    }
  };

  console.log("gnid test", gnid);

  const PostData = async () => {
    setLoading(true);
    let response;
    if (stage_id === 3) {
      // response = await Api.submitStage({
      //   fiscal_year_id: fiscalYear,
      //   completion_date: date,
      //   stage_id: stage_id,
      //   ministry_id: gnid
      // });
      response = await Api.submitMinistryStage({
        fiscal_year_id: fiscalYear,
        stage_id: stage_id,
        ministry_id: gnid,
      });
    } else {
      // response = await Api.submitStage({
      //   fiscal_year_id: fiscalYear,
      //   stage_id: stage_id,
      //   ministry_id: gnid
      // });
      response = await Api.submitMinistryStage({
        fiscal_year_id: fiscalYear,
        stage_id: stage_id,
        ministry_id: gnid,
      });
    }

    if (response.code === 200) {
      toast.success(response.message, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 5000,
      });
      setModal(!modal);
      setLoading(false);
      window.location.reload(true);
    } else if (response.code === 201) {
      toast.error(response.message, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 5000,
      });
      setModal(!modal);
      setLoading(false);
    } else {
      toast.error(response.message, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 5000,
      });
      setModal(!modal);
      setLoading(false);
    }
  };
  console.log("stage_id", stage_id);

  return comment === true ? (
    <div className="comment-box">
      <span onClick={toggle} className="qn-counter">
        {commentCount}
      </span>
      <i onClick={toggle} class="far fa-comments"></i>
      <Modal
        returnFocusAfterClose={false}
        isOpen={modal}
        toggle={toggle}
        className={"modal-lg modal-dialog-centered comments-wrap"}
      >
        <ModalHeader toggle={toggle}>पृष्ठपोषण </ModalHeader>
        <ModalBody>
          <Comments
            posted={posted}
            question_id={question_id}
            fiscal_year_id={fiscalYear}
            ocmcm_id={ocmcm_id}
          />
        </ModalBody>
        <ModalFooter>
          <form onSubmit={PostComment} className="footer-wrapper row">
            <div className="comment-input col-md-12">
              <input
                {...bindComment}
                placeholder="Add Comment"
                type="textarea"
              ></input>
            </div>
            {/* <div className="comment-input"> */}
            <Button
              type="submit"
              disabled={message === "" ? true : false}
              color="primary"
              // onClick={() => {
              //   PostComment();
              // }}
            >
              स्वीकृत गर्नुहोस
            </Button>{" "}
            {/* <Button color="secondary" onClick={toggle}>
            Cancel
          </Button> */}
            {/* </div> */}
          </form>
        </ModalFooter>
      </Modal>
    </div>
  ) : dateRequired === true ? (
    <div>
      <Button
        disabled={disabled === stage_id ? false : true}
        color="primary"
        onClick={toggle2}
      >
        मिति छान्नुहोस्
      </Button>
      <Modal
        returnFocusAfterClose={false}
        isOpen={modal2}
        toggle={toggle2}
        className={"modal-sm modal-dialog-centered"}
      >
        <ModalHeader toggle={toggle2}>मिति चयन गर्नुहोस्। </ModalHeader>
        <ModalBody>
          <NepaliDatePicker
            onDateSelect={getDate}
            placeholderText="कृपया मिति चयन गर्नुहोस्।"
          />
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            className="button-loader"
            disabled={
              date === undefined || date === "" || loading
                ? true
                : false || pastDate
            }
            onClick={() => {
              PostData();
            }}
          >
            स्वीकृत गर्नुहोस
            {loading ? (
              <Loader
                type="Oval"
                color="#FFF"
                height={15}
                width={15}
                timeout={3000} //3 secs
              />
            ) : (
              ""
            )}
          </Button>{" "}
          <Button color="secondary" onClick={toggle2}>
            रद्द गर्नुहोस्
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  ) : (
    <div>
      {console.log("first test", disabled, stage_id, localData)}
      <Button
        // disabled={disabled !== stage_id ? false : true}
        disabled={
          // disabled !== stage_id ||
          (disabled === 3 && localData === 6) ||
          (disabled === 4 && localData === 3)
            ? // (disabled === 5 && localData === 2)
              false
            : true
        }
        color="primary"
        onClick={toggle}
      >
        स्वीकृत गर्नुहोस
      </Button>
      <Modal
        returnFocusAfterClose={false}
        isOpen={modal}
        toggle={toggle}
        className={"modal-sm modal-dialog-centered"}
      >
        <ModalHeader toggle={toggle}>
          के तपाई नतिजा स्वीकृत गर्न चाहनुहुन्छ ?{" "}
        </ModalHeader>
        <ModalFooter>
          <Button
            color="primary"
            className="button-loader"
            onClick={() => {
              PostData();
            }}
          >
            स्वीकृत गर्नुहोस
            {loading ? (
              <Loader
                type="Oval"
                color="#FFF"
                height={15}
                width={15}
                timeout={300000} //3 secs
              />
            ) : (
              ""
            )}
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            रद्द गर्नुहोस्
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}
